<template>
  <div
    v-scroll-lock
    class="animate__animated animate__fadeIn fixed inset-0 mx-auto h-full flex flex-col items-center bg-black/50 z-10 overflow-y-auto"
    :class="skinPadding"
    @click.self="handleClose"
  >
    <div
      ref="content"
      class="animate__animated animate__fadeInUpBig w-full m-auto flex flex-col rounded-2xl bg-white"
      :class="contentClass"
    >
      <!-- Header -->
      <div v-if="isHeader" class="p-4 bg-capino-light rounded-2xl md:p-6">
        <div class="flex items-center justify-between">
          <h2 class="text-lg md:text-2xl font-bold text-gray-900">
            {{ headerTitle }}
          </h2>

          <button
            v-if="isCloseButton"
            class="p-2 hover:bg-capino-light text-gray-500 rounded-full transition-color z-[2]"
            @click="handleClose"
          >
            <BaseIcon icon="cross" class="w-5 h-5" />
          </button>
        </div>
      </div>

      <slot />
    </div>
  </div>
</template>

<script>
import { animate } from 'motion'

import BaseIcon from '@/components/Base/BaseIcon.vue'

export default {
  name: 'BaseModal',

  components: { BaseIcon },

  props: {
    headerTitle: { type: String, default: '' },
    contentClass: { type: String, default: 'max-w-6xl max-h-[95vh]' },
    skinPadding: { type: String, default: 'p-8' },
    isHeader: { type: Boolean, default: true },
    isCloseButton: { type: Boolean, default: true }
  },

  mounted() {
    document.body.appendChild(this.$el)
  },

  beforeDestroy() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el)
    }
  },

  methods: {
    handleClose() {
      this.$refs.content.classList.add('animate__fadeOutDownBig')

      animate(this.$el, { opacity: 0 }, { duration: 0.3 }).finished.then(() => {
        this.$emit('close')
      })
    }
  }
}
</script>
